/*
 * PVS in-house Back-in-Stock notify button.
 * No third-party app: shows a "Notify me when it's back in stock" control on
 * sold-out variants and subscribes the shopper through Klaviyo's client-side
 * back-in-stock API (public key only, safe in the browser).
 *
 * TEMPLATE-AGNOSTIC BY DESIGN. Every PVS product template hand-rolls its own
 * buy form (pvs-product's .hero-cart, urnieta's <select name="id">,
 * steering-wheel's .pvs-addtocart, the combo pages' /cart/add.js buttons), so
 * this file must never depend on one theme's markup:
 *   - availability comes from window.PVS_BIS_CONFIG.variants, rendered by
 *     snippets/pvs-back-in-stock.liquid straight out of Liquid;
 *   - the DOM is used only to find an anchor to sit under and to read whichever
 *     variant the shopper currently has selected.
 * The original version anchored off [name="add"], which no PVS template renders
 * any more, so the button silently stopped appearing on every product page.
 */
(function () {
  var CFG = window.PVS_BIS_CONFIG || {};
  var COMPANY_ID = CFG.companyId;
  if (!COMPANY_ID || !CFG.variants || !CFG.variants.length) return;

  var REVISION = CFG.revision || '2025-07-15';
  var ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + COMPANY_ID;
  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

  var BY_ID = {};
  var UNAVAILABLE = [];
  CFG.variants.forEach(function (v) {
    BY_ID[String(v.id)] = v;
    if (!v.available) UNAVAILABLE.push(v);
  });
  if (!UNAVAILABLE.length) return; // nothing sold out on this product

  var state = { widget: null, variantId: null, sent: {} };

  /* ---------- which variant is on screen right now ---------------------- */

  // Any control the theme uses to carry the variant id: a hidden input, the
  // configurator's .pvs-variant-id, or urnieta's <select name="id">. We accept
  // whichever one holds a value that is a real variant of this product.
  function selectedVariantId() {
    var nodes = document.querySelectorAll('[name="id"], .pvs-variant-id');
    for (var i = 0; i < nodes.length; i++) {
      var val = (nodes[i].value || '').trim();
      if (val && BY_ID[val]) return val;
    }
    return null;
  }

  /* ---------- where to put ourselves ------------------------------------ */

  function buyButton() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var btn = forms[i].querySelector('[name="add"], button[type="submit"], input[type="submit"]');
      if (btn) return btn;
    }
    // Templates that post through /cart/add.js instead of a real form.
    var js = document.querySelector('[data-hu-satc-add], .pvs-addtocart, [data-add-to-cart]');
    if (js) return js;
    // Last resort: a disabled control that literally says Sold out.
    var buttons = document.querySelectorAll('button, a.btn');
    for (var j = 0; j < buttons.length; j++) {
      var text = (buttons[j].textContent || '').trim().toLowerCase();
      if (text.indexOf('sold out') === 0 || text.indexOf('coming soon') === 0) return buttons[j];
    }
    return null;
  }

  function anchorFor(btn) {
    // Sit under the whole buy block rather than in the middle of it, and stay
    // outside any region the theme re-renders on variant change.
    return btn.closest('.hero-cart') || btn.closest('product-form') || btn.parentElement;
  }

  /* ---------- the widget ------------------------------------------------ */

  function buildWidget() {
    if (state.widget && document.body.contains(state.widget)) return state.widget;

    var btn = buyButton();
    if (!btn) return null;
    var anchor = anchorFor(btn);
    if (!anchor || !anchor.parentNode) return null;

    var el = document.createElement('div');
    el.className = 'pvs-bis';
    el.setAttribute('hidden', '');
    el.innerHTML =
      '<button type="button" class="pvs-bis__open">Notify me when it’s back in stock</button>' +
      '<div class="pvs-bis__panel" hidden>' +
        '<p class="pvs-bis__lead">Enter your email and we’ll let you know the moment it’s back in stock.</p>' +
        '<select class="pvs-bis__variant" aria-label="Which option do you want?" hidden></select>' +
        '<div class="pvs-bis__row">' +
          '<input type="email" class="pvs-bis__email" placeholder="you@email.com" autocomplete="email" inputmode="email" aria-label="Email address">' +
          '<button type="button" class="pvs-bis__submit">Notify me</button>' +
        '</div>' +
        '<div class="pvs-bis__msg" role="status" aria-live="polite" hidden></div>' +
      '</div>';

    anchor.parentNode.insertBefore(el, anchor.nextSibling);
    wire(el);
    state.widget = el;
    return el;
  }

  // Shown only when the shopper cannot pick the sold-out option on the page
  // itself: urnieta disables its sold-out <option>s, so without this there is
  // no way to say WHICH size or colour you want told about.
  function fillVariantPicker(el) {
    var picker = el.querySelector('.pvs-bis__variant');
    if (UNAVAILABLE.length < 2) { picker.setAttribute('hidden', ''); return; }

    if (!picker.options.length) {
      UNAVAILABLE.forEach(function (v) {
        var opt = document.createElement('option');
        opt.value = String(v.id);
        opt.textContent = v.title;
        picker.appendChild(opt);
      });
    }
    if (state.variantId && BY_ID[state.variantId] && !BY_ID[state.variantId].available) {
      picker.value = state.variantId;
    }
    picker.removeAttribute('hidden');
  }

  function wire(el) {
    var openBtn = el.querySelector('.pvs-bis__open');
    var panel = el.querySelector('.pvs-bis__panel');
    var picker = el.querySelector('.pvs-bis__variant');
    var email = el.querySelector('.pvs-bis__email');
    var submit = el.querySelector('.pvs-bis__submit');
    var msg = el.querySelector('.pvs-bis__msg');

    if (CFG.email) email.value = CFG.email;

    openBtn.addEventListener('click', function () {
      openBtn.setAttribute('hidden', '');
      fillVariantPicker(el);
      panel.removeAttribute('hidden');
      email.focus();
    });

    function showMsg(text, kind) {
      msg.textContent = text;
      msg.className = 'pvs-bis__msg' + (kind ? ' is-' + kind : '');
      msg.removeAttribute('hidden');
    }

    function targetVariant() {
      if (!picker.hasAttribute('hidden') && picker.value) return picker.value;
      if (state.variantId && BY_ID[state.variantId] && !BY_ID[state.variantId].available) return state.variantId;
      return String(UNAVAILABLE[0].id);
    }

    function send() {
      var value = (email.value || '').trim();
      if (!EMAIL_RE.test(value)) { showMsg('Please enter a valid email address.', 'error'); email.focus(); return; }

      var variantId = targetVariant();
      if (!variantId) { showMsg('Sorry, we could not identify this item. Please refresh and try again.', 'error'); return; }

      submit.setAttribute('disabled', '');
      submit.textContent = 'Sending…';
      msg.setAttribute('hidden', '');

      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: REVISION },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: { data: { type: 'profile', attributes: { email: value } } }
            },
            relationships: {
              variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
            }
          }
        })
      }).then(function (res) {
        if (res.ok || res.status === 202) {
          state.sent[variantId] = true;
          el.querySelector('.pvs-bis__lead').setAttribute('hidden', '');
          picker.setAttribute('hidden', '');
          el.querySelector('.pvs-bis__row').setAttribute('hidden', '');
          showMsg('You’re on the list. We’ll email you the moment it’s back in stock.', 'success');
        } else {
          submit.removeAttribute('disabled');
          submit.textContent = 'Notify me';
          showMsg('Something went wrong. Please try again in a moment.', 'error');
        }
      }).catch(function () {
        submit.removeAttribute('disabled');
        submit.textContent = 'Notify me';
        showMsg('Something went wrong. Please try again in a moment.', 'error');
      });
    }

    submit.addEventListener('click', send);
    email.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); send(); } });
  }

  /* ---------- show / hide ----------------------------------------------- */

  // Show when the selected variant is sold out. With nothing selected yet, show
  // only if the whole product is sold out, so a partly stocked product does not
  // greet everyone with a notify button before they have chosen anything.
  function shouldShow() {
    var id = selectedVariantId();
    state.variantId = id;
    if (id) return BY_ID[id] && BY_ID[id].available === false;
    return UNAVAILABLE.length === CFG.variants.length;
  }

  function refresh() {
    var show = shouldShow();
    var el = show ? buildWidget() : state.widget;
    if (!el) return;
    if (show) {
      el.removeAttribute('hidden');
      var picker = el.querySelector('.pvs-bis__variant');
      if (picker && !picker.hasAttribute('hidden')) fillVariantPicker(el);
    } else {
      el.setAttribute('hidden', '');
    }
  }

  // Themes swap the variant by assigning input.value, which fires no DOM
  // mutation, so listen for the interactions that cause it and keep a light
  // poll as the backstop for templates that update on their own schedule.
  document.addEventListener('change', refresh, true);
  document.addEventListener('click', function () { setTimeout(refresh, 60); }, true);
  document.addEventListener('on:variant:change', refresh);
  setInterval(refresh, 900);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
